module.exports = "img/flags/IQ.793d689.png";